import React from 'react';
import classNames from 'classnames/bind';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import Link from 'next/link';
import { parseTextWithLinksAndBold } from 'sections/Resources/FreightDictionary/helpers/textParser';
import styles from 'sections/Resources/FreightDictionary/landing/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

type SectionHeaderProps = {
  titleH1: string;
  headParagraphs?: string[];
};

const SectionHeader = ({ titleH1, headParagraphs }: SectionHeaderProps) => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <div className={cn('header__content')}>
          <div className={cn('header__description')}>
            <h1 className={cn('header__heading')}>
              {titleH1}
            </h1>
            <div className={cn('header__paragraphs')}>
              {headParagraphs ?
                headParagraphs.map((paragraph, idx) => (
                  <p key={idx} className={cn('header__paragraph')}>
                    {parseTextWithLinksAndBold(paragraph, cn, 'header')}
                  </p>
                )) : (
                  <p className={cn('header__paragraph')}>
                    {`Find the abbreviation, definition, and use case of ${titleH1}`}
                  </p>
                )
              }
            </div>
            {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
            {/* <div className={cn('header__buttons')}>
              <Link className={cn('header__button-join')} href="/membership">
                Get membership NOW!
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;
